import { api } from "./api";

export class PoliceReportTypeService {
  async post(value: string) {
    try {
      const response = await api.post(`/police-report-type`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async get() {
    try {
      const response = await api.get(`/police-report-type`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async getById(id: string) {
    try {
      const response = await api.get(`/police-report-type/${id}`);
      return response.data.data;
    } catch (error: any) {
      return error.response;
    }
  }

  async patch(value: string, id: string) {
    try {
      const response = await api.patch(`/police-report-type/${id}`, value);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }

  async delete(id: string) {
    try {
      const response = await api.delete(`/police-report-type/${id}`);
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
}
